import {
  repeatedCharacters,
  serialNumbers,
  serialCharacters,
  specialCharacters,
  containNumbers,
  hasLowerAndUpper,
} from './validations'

export const createScoreLabel = (score) => {
  switch (score) {
    case 0:
      return 'start'
    case 1:
    case 2:
    case 3:
      return 'weak'
    case 4:
    case 5:
    case 6:
      return 'medium'
    case 7:
      return 'strong'
    default:
      return 'start'
  }
}

export const getLevelScore = (text) => {
  // si no ha completado al menos nueve caracteres
  // no podemos subir a medium
  if (text.length < 9) {
    return 3
  }
  let totalScore = 0
  if (!repeatedCharacters.test(text)) {
    ++totalScore
  }
  if (!serialNumbers.test(text)) {
    ++totalScore
  }
  if (!serialCharacters.test(text)) {
    ++totalScore
  }
  if (specialCharacters.test(text)) {
    ++totalScore
  }
  if (containNumbers.test(text)) {
    ++totalScore
  }
  if (hasLowerAndUpper.test(text)) {
    ++totalScore
  }
  if (text.length > 10 && text.length < 64) {
    ++totalScore
  }
  return totalScore
}
